<template>
  <div>
    <header class="ts-app-header capture-shell sga-header">
      <a :href="goToDashbard" class="logo">
        <img
          src="~../assets/img/logo.svg"
          alt="TalentSensus"
          class="logo_icon"
        />
      </a>
      <div class="el-steps el-steps--horizontal" style="width: 75% !important; margin: auto !important;">
        <CircleStep :TotalSteps="12" :StepNumber="1" :CurrentStep="currentPage" :Data="currentSga.sgaEmployeeInfo" StepRoutePath="/sga/questionnaire"></CircleStep>
        <CircleStep :TotalSteps="12" :StepNumber="2" :CurrentStep="currentPage" :Data="currentSga.sgaYourJob" StepRoutePath="/sga/questionnaire/2"></CircleStep>
        <CircleStep :TotalSteps="12" :StepNumber="3" :CurrentStep="currentPage" :Data="currentSga.sgaEducation" StepRoutePath="/sga/questionnaire/3"></CircleStep>
        <CircleStep :TotalSteps="12" :StepNumber="4" :CurrentStep="currentPage" :Data="currentSga.sgaWorkHistory" StepRoutePath="/sga/questionnaire/4"></CircleStep>
        <CircleStep :TotalSteps="12" :StepNumber="5" :CurrentStep="currentPage" :Data="currentSga.sgaCertifications" StepRoutePath="/sga/questionnaire/5"></CircleStep>
        <CircleStep :TotalSteps="12" :StepNumber="6" :CurrentStep="currentPage" :Data="currentSga.sgaHiddenExtras" StepRoutePath="/sga/questionnaire/6"></CircleStep>
        <CircleStep :TotalSteps="12" :StepNumber="7" :CurrentStep="currentPage" :Data="currentSga.sgaKnowledge" StepRoutePath="/sga/questionnaire/7"></CircleStep>
        <CircleStep :TotalSteps="12" :StepNumber="8" :CurrentStep="currentPage" :Data="currentSga.sgaTechnologies" StepRoutePath="/sga/questionnaire/8"></CircleStep>
        <CircleStep :TotalSteps="12" :StepNumber="9" :CurrentStep="currentPage" :Data="currentSga.sgaMindset" StepRoutePath="/sga/questionnaire/9"></CircleStep>
        <CircleStep :TotalSteps="12" :StepNumber="10" :CurrentStep="currentPage" :Data="currentSga.sgaSkills" StepRoutePath="/sga/questionnaire/10"></CircleStep>
        <CircleStep :TotalSteps="12" :StepNumber="11" :CurrentStep="currentPage" :Data="currentSga.sgaHiddenTalents" StepRoutePath="/sga/questionnaire/11"></CircleStep>
        <CircleStep :TotalSteps="12" :StepNumber="12" :CurrentStep="currentPage" :Data="currentSga.culture" StepRoutePath="/sga/questionnaire/12"></CircleStep>
      </div> 
       <!-- <el-steps :align-center="true" :active="currentPage" process-status="process" style="width: 75% !important; margin: auto !important;">
        <el-step></el-step>
        <el-step></el-step>
        <el-step></el-step>
        <el-step></el-step>
        <el-step></el-step>
        <el-step></el-step>
        <el-step></el-step>
        <el-step></el-step>
        <el-step></el-step>
        <el-step></el-step>
      </el-steps> -->
      <div class="ts-app-header--actions">
        <el-dropdown trigger="click">
          <span
            ><i
              style="color: #14223c; font-size: 20px"
              class="fas fa-user-cog"
            ></i
          ></span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item class="el-dropdown-menu__item"
              ><span @click="showResumeList"
                >Export to CV</span
              ></el-dropdown-item
            >
            <el-dropdown-item class="el-dropdown-menu__item"
              ><span @click="print" class="print-sga"
                >Print Details</span
              ></el-dropdown-item
            >
            <el-dropdown-item class="el-dropdown-menu__item--divided"
              ><span @click="goToUserProfileSettings"
                >Public Profile/Resume</span
              ></el-dropdown-item
            >
          </el-dropdown-menu>
        </el-dropdown>

        <span class="menu-divider"></span>

        <span @click="doLogout()" class="ts-hub-link">
          <el-button type="text"
            ><i class="fas fa-sign-out-alt"></i> Logout</el-button
          >
        </span>
      </div>
    </header>

    <!-- MOBILE PROGRESS BAR -->
    <header class="ts-app-header capture-shell sga-mobile-header">
      <div class="logo-logout-bar">
        <div class="logo-area">
          <a :href="goToDashbard">
            <img
              src="~../assets/img/logos/us-logo-circle.png"
              alt="TalentSensus"
            />
          </a>
        </div>
        <div class="sga-steps">
          <div class="step-num">
            <span> {{ currentPage }} / 12 </span>
            <div class="step-name">
              {{ currentPageName }}
            </div>
          </div>
        </div>
        <!-- <div class="back-home-link">
          <a href="/">
            <i class="fas fa-home"></i>
            </a>
        </div> -->
      </div>
    </header>

    <main class="ts-app-capture sga">
      <router-view></router-view>
    </main>

    <!-- Negate the isValidSession value of false to show the session update modal -->
    <SessionUpdate
      :showModal="!isValidSession"
      @close-modal="closeSessionUpdateModal"
    />

  </div>
</template>

<script>
import Vue from "vue";
import { LockIcon } from "vue-feather-icons";
// import * as signalR from "@aspnet/signalr";
import CircleStep from "../modules/sga-questionnaire/components/CircleStep.vue";
import SessionUpdate from "@/components/SessionUpdate.vue";
import loginUtils from "@/utils/login.utils";

export default {
  components: {
    LockIcon,
    CircleStep,
    SessionUpdate
  },
  created() {
    this.$store.dispatch('sga/getsga')
      .then((res) => {          
      // setting the locale
      var lslocale = localStorage.getItem("locale");
      if (lslocale != null) {
        if (lslocale == "en") {
          this.flag = "en-US";
          localStorage.setItem("locale", "en-US");
        } else {
          this.flag = lslocale;
        }
      } else {
        localStorage.setItem("locale", "en-US");
      }

      // set exchange rate
      var locale = localStorage.getItem("locale");
      this.$i18n.locale = locale;
      Vue.prototype.$ExchangeRates = this.exchangeRates;
    });
    //TODO: Reevaluate code below
    // this.initializeSignalR();
  },
  data() {
    return {
      connection: {},
      huburl: process.env.VUE_APP_MESSAGE_BASE_URI,
      isValidSession: loginUtils.checkLoginStatus(),
    };
  },
  computed: {
    currentPage() {
      return this.$route.meta.currentPage;
    },
    currentPageName() {
      return this.$route.meta.label;
    },
    currentRouteName() {
      return this.$route.name;
    },
    goToDashbard() {
      const isApprentice = this.$store.state.account.current_user.roles.includes('Apprentice');
      if (isApprentice) {
        return "/apprentice-dashboard";
      } else {
        return "/jobseeker-dashboard";
      }
    },
    currentSga() {
      return this.$store.state.sga.current_sga;
    },
    sessionChecker() {
      return process.env.VUE_APP_SESSION_CHECKER_INTERVAL;
    },
  },
  methods: {
    doLogout() {
      if (sessionStorage.getItem("fromSuperAdmin") != null) {
        this.connection.invoke("JobSeekerDebugEnded", "").catch(function (err) {
          return console.error(err.toString());
        });
      }

      this.$store.dispatch("account/logout").then((res) => {
        const isApprentice = this.$store.state.account.current_user.roles.includes('Apprentice');      
        commit("SET_USER", null);

        if (isApprentice) {
          window.location = window.location.origin + "/apprentice-login";
        } else {
          window.location = window.location.origin + "/jobseeker-login";
        }
      });
    },
    print() {
      this.$router.app.$emit("questionnaire-print", this.windowPrint);
    },
    printAsCV() {
      this.$router.app.$emit("cv-print", this.windowPrint);
    },
    showResumeList() {
      this.$router.app.$emit("show-resume-list");
    },
    windowPrint() {
      window.print();
    },
    //TODO: Reevaluate code below
    // initializeSignalR() {
    //   this.connection = new signalR.HubConnectionBuilder()
    //     .withUrl(this.huburl, {
    //       transport:
    //         signalR.HttpTransportType.WebSockets |
    //         signalR.HttpTransportType.LongPolling,
    //       "content-type": "application/json",
    //       accessTokenFactory: () => localStorage.getItem("token"),
    //     })
    //     .build();

    //   this.connection.start().catch(function (err) {
    //     return console.error(err.toString());
    //   });
    // },
    goToUserProfileSettings() {
      this.$confirm(
        `<p style="text-align:center">Are you sure you want to go the Public Profile/Resume page? All your changes will be lost on this page.</p><br>`,
        "Warning",
        {
          confirmButtonText: "Yes",
          cancelButtonText: "No",
          type: "warning",
          dangerouslyUseHTMLString: true,
          center: true,
        }
      ).then(() => {
        const isApprentice = this.$store.state.account.current_user.roles.includes('Apprentice');
        if (isApprentice) {
          this.$router.push({ name: "ApprenticeProfilePageSetting" });
        } else {
          this.$router.push({ name: "JobSeekerProfilePageSetting" });
        }
      });
    },
    closeSessionUpdateModal() {
      this.isValidSession = true;
    },
  },
  mounted() {
    setInterval(() => {
      this.isValidSession = loginUtils.checkLoginStatus();
    }, this.sessionChecker); // Check every set time for login status
  },
};
</script>
